import firebase from '../../constants/firebase';

export const deleteLocation = (locationId) => {
    const db = firebase.firestore()
    db.collection('locations').doc(locationId).delete().then(() => {
        console.warn("Document successfully deleted!");
    }).catch((error) => {
        console.error("Error removing document: ", error);
    })
}